/**
 * __mocks__/apiResponses/v3/clinician.js
 * Autogenerated via generateMockRoute.js
 * DO NOT MODIFY THIS FILE STRUCTURE DIRECTLY.
 */

/** @type {import('../../mockRequestHandler').EndpointMockConfig} */
export default {
  "v3/clinician/:clinicianid/matching-sessions": {
    active: true,
    GET: {
      active: true,
      default: {
        responseValues: {
          response: [],
          status: 204,
        },
      },
      scenarios: {
        no_matching_sessions: {
          active: true,
          condition: {
            urlParams: {
              clinicianid: "145163", // <- use your target clinician's clinicianid
            },
          },
          responseValues: {
            response: {
              nonWorkingHours: [
                {
                  endDateTime: "2025-02-17T14:00:00.000Z",
                  startDateTime: "2025-02-16T05:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-17T23:00:00.000Z",
                  endDateTime: "2025-02-18T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-18T23:00:00.000Z",
                  endDateTime: "2025-02-19T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-19T23:00:00.000Z",
                  endDateTime: "2025-02-20T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-20T23:00:00.000Z",
                  endDateTime: "2025-02-21T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-21T23:00:00.000Z",
                  endDateTime: "2025-02-24T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-24T23:00:00.000Z",
                  endDateTime: "2025-02-25T05:00:00.000Z",
                },
              ],
              calendarSessions: [
                {
                  id: 50635,
                  client_user_id: null,
                  client_id: "144497",
                  clinician_user_id: null,
                  room_id: null,
                  start_date: null,
                  end_date: null,
                  scheduled_date: "2025-02-17T17:30:00.000Z",
                  user_guid: null,
                  vyte_id: null,
                  start_signature_url: null,
                  end_signature_url: null,
                  end_bcba_signature_url: null,
                  start_bcba_signature_url: null,
                  call_type: "Assessment",
                  actual_time: null,
                  billable_units: null,
                  video_key: "cm6pswv7n000f1vjw9y4c5d5c",
                  is_test: false,
                  needs_notes: true,
                  off_platform: false,
                  no_show: false,
                  call_duration: 60,
                  secondary_clinician_user_id: null,
                  legacy_notes: false,
                  billing_type: "DIRECT_THERAPY",
                  healthie_video_call_id: null,
                  call_timezone: "America/Chicago",
                  is_recurring: true,
                  parent_video_call_id: "50629",
                  start_time: null,
                  begin_date: null,
                  stop_date: null,
                  stop_type: null,
                  canceled: false,
                  rescheduled: false,
                  video_chat_url:
                    "sendbird_group_channel_191722745_857651b617c3830d25c20a9bdd8c50b2f5af2de6",
                  call_instructions: null,
                  repeat_days: "1,3,5",
                  repeat_type: "until_date",
                  repeat_weeks: null,
                  repeat_until_date: "2025-05-30T04:00:00.000Z",
                  cancel_reason: null,
                  off_platform_type: null,
                  not_started: false,
                  responsible_for_cancellation: null,
                  cancel_date: null,
                  removed: false,
                  healthie_scheduled: false,
                  created_date: "2025-02-04T01:28:42.744Z",
                  onsched_appointment_id: null,
                  description: null,
                  time_interval: 1,
                  time_unit: "weeks",
                  billable_time_id: null,
                  is_tentative: false,
                  master_call_instructions: null,
                  name: "Insurance",
                  child_last_name: "Database",
                  user_id: "145465",
                  primary_clinician_user_id: "144804",
                  client_name: "Insurance Database",
                  team_member_name: "Insurance Database",
                  clinician_name: "Allie Director",
                  secondary_clinician_name: " ",
                  team_member_image_url: null,
                  clinician_id: "145163",
                  clinician_image_url:
                    "https://an-user-profile-images-staging.s3.amazonaws.com/6763c36d-5aa4-4d9d-80dc-58e4e25aa709/profile_image.png",
                  secondary_clinician_id: null,
                  secondary_clinician_image_url: null,
                  billing_complete: null,
                  video_call_user_id: "144804",
                  is_video_call: true,
                },
                {
                  id: 50997,
                  client_user_id: null,
                  client_id: "143883",
                  clinician_user_id: null,
                  room_id: null,
                  start_date: null,
                  end_date: null,
                  scheduled_date: "2025-02-21T19:00:00.000Z",
                  user_guid: null,
                  vyte_id: null,
                  start_signature_url: null,
                  end_signature_url: null,
                  end_bcba_signature_url: null,
                  start_bcba_signature_url: null,
                  call_type: "Therapy",
                  actual_time: null,
                  billable_units: null,
                  video_key: "cm73o6ta4000p1vjw5wqvh129",
                  is_test: false,
                  needs_notes: true,
                  off_platform: false,
                  no_show: false,
                  call_duration: 60,
                  secondary_clinician_user_id: null,
                  legacy_notes: false,
                  billing_type: "CAREGIVER_TRAINING",
                  healthie_video_call_id: null,
                  call_timezone: "America/New_York",
                  is_recurring: true,
                  parent_video_call_id: "50993",
                  start_time: null,
                  begin_date: null,
                  stop_date: null,
                  stop_type: null,
                  canceled: false,
                  rescheduled: false,
                  video_chat_url:
                    "sendbird_group_channel_191722745_4621ecf678104b5f9f7e40d156ba8bd8a653d619",
                  call_instructions: null,
                  repeat_days: "1,3,5",
                  repeat_type: "until_date",
                  repeat_weeks: null,
                  repeat_until_date: "2025-02-21T06:00:00.000Z",
                  cancel_reason: null,
                  off_platform_type: null,
                  not_started: false,
                  responsible_for_cancellation: null,
                  cancel_date: null,
                  removed: false,
                  healthie_scheduled: false,
                  created_date: "2025-02-13T18:25:14.561Z",
                  onsched_appointment_id: null,
                  description: null,
                  time_interval: 1,
                  time_unit: "weeks",
                  billable_time_id: null,
                  is_tentative: false,
                  master_call_instructions: null,
                  name: "dd",
                  child_last_name: "ddTest",
                  user_id: "144490",
                  primary_clinician_user_id: "144804",
                  client_name: "dd ddTest",
                  team_member_name: "Parentddd Test",
                  clinician_name: "Allie Director",
                  secondary_clinician_name: " ",
                  team_member_image_url: null,
                  clinician_id: "145163",
                  clinician_image_url:
                    "https://an-user-profile-images-staging.s3.amazonaws.com/6763c36d-5aa4-4d9d-80dc-58e4e25aa709/profile_image.png",
                  secondary_clinician_id: null,
                  secondary_clinician_image_url: null,
                  billing_complete: null,
                  video_call_user_id: "144804",
                  is_video_call: true,
                },
                {
                  billing_type: "DIRECT_THERAPY",
                  call_duration: 60,
                  is_tentative: true,
                  client_id: "144752",
                  client_name: "Rita Lopez",
                  clinician_id: "145163",
                  clinician_name: "Allie Director",
                  clinician_image_url:
                    "https://an-user-profile-images-staging.s3.amazonaws.com/9f8d6afa-16e8-4c99-9dc6-1e3831027660/profile_image.png",
                  end: new Date("2025-02-18T20:00:00.000Z"),
                  start: new Date("2025-02-18T21:00:00.000Z"),
                  title: "Client Transition",
                  googleEvent: false,
                  no_show: false,
                  canceled: false,
                  team_member_image_url: null,
                  team_member_name: "Thomas Montes",
                  isNoSelectable: true,
                },
              ],
            },
            status: 200,
          },
        },
        two_matching_sessions: {
          active: true,
          condition: {
            urlParams: {
              clinicianid: "145162", // <- use your target clinician's clinicianid
            },
          },
          responseValues: {
            status: 200,
            response: {
              nonWorkingHours: [
                {
                  endDateTime: "2025-02-17T14:00:00.000Z",
                  startDateTime: "2025-02-16T05:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-17T23:00:00.000Z",
                  endDateTime: "2025-02-18T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-18T23:00:00.000Z",
                  endDateTime: "2025-02-19T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-19T23:00:00.000Z",
                  endDateTime: "2025-02-20T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-20T23:00:00.000Z",
                  endDateTime: "2025-02-21T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-21T23:00:00.000Z",
                  endDateTime: "2025-02-24T14:00:00.000Z",
                },
                {
                  startDateTime: "2025-02-24T23:00:00.000Z",
                  endDateTime: "2025-02-25T05:00:00.000Z",
                },
              ],
              calendarSessions: [
                {
                  id: 50635,
                  client_user_id: null,
                  client_id: "144497",
                  clinician_user_id: null,
                  room_id: null,
                  start_date: null,
                  end_date: null,
                  scheduled_date: "2025-02-17T17:30:00.000Z",
                  user_guid: null,
                  vyte_id: null,
                  start_signature_url: null,
                  end_signature_url: null,
                  end_bcba_signature_url: null,
                  start_bcba_signature_url: null,
                  call_type: "Assessment",
                  actual_time: null,
                  billable_units: null,
                  video_key: "cm6pswv7n000f1vjw9y4c5d5c",
                  is_test: false,
                  needs_notes: true,
                  off_platform: false,
                  no_show: false,
                  call_duration: 60,
                  secondary_clinician_user_id: null,
                  legacy_notes: false,
                  billing_type: "DIRECT_THERAPY",
                  healthie_video_call_id: null,
                  call_timezone: "America/Chicago",
                  is_recurring: true,
                  parent_video_call_id: "50629",
                  start_time: null,
                  begin_date: null,
                  stop_date: null,
                  stop_type: null,
                  canceled: false,
                  rescheduled: false,
                  video_chat_url:
                    "sendbird_group_channel_191722745_857651b617c3830d25c20a9bdd8c50b2f5af2de6",
                  call_instructions: null,
                  repeat_days: "1,3,5",
                  repeat_type: "until_date",
                  repeat_weeks: null,
                  repeat_until_date: "2025-05-30T04:00:00.000Z",
                  cancel_reason: null,
                  off_platform_type: null,
                  not_started: false,
                  responsible_for_cancellation: null,
                  cancel_date: null,
                  removed: false,
                  healthie_scheduled: false,
                  created_date: "2025-02-04T01:28:42.744Z",
                  onsched_appointment_id: null,
                  description: null,
                  time_interval: 1,
                  time_unit: "weeks",
                  billable_time_id: null,
                  is_tentative: false,
                  master_call_instructions: null,
                  name: "Insurance",
                  child_last_name: "Database",
                  user_id: "145465",
                  primary_clinician_user_id: "144804",
                  client_name: "Insurance Database",
                  team_member_name: "Insurance Database",
                  clinician_name: "Allie Director",
                  secondary_clinician_name: " ",
                  team_member_image_url: null,
                  clinician_id: "145162",
                  clinician_image_url:
                    "https://an-user-profile-images-staging.s3.amazonaws.com/6763c36d-5aa4-4d9d-80dc-58e4e25aa709/profile_image.png",
                  secondary_clinician_id: null,
                  secondary_clinician_image_url: null,
                  billing_complete: null,
                  video_call_user_id: "144804",
                  is_video_call: true,
                },
                {
                  id: 50997,
                  client_user_id: null,
                  client_id: "143883",
                  clinician_user_id: null,
                  room_id: null,
                  start_date: null,
                  end_date: null,
                  scheduled_date: "2025-02-21T19:00:00.000Z",
                  user_guid: null,
                  vyte_id: null,
                  start_signature_url: null,
                  end_signature_url: null,
                  end_bcba_signature_url: null,
                  start_bcba_signature_url: null,
                  call_type: "Therapy",
                  actual_time: null,
                  billable_units: null,
                  video_key: "cm73o6ta4000p1vjw5wqvh129",
                  is_test: false,
                  needs_notes: true,
                  off_platform: false,
                  no_show: false,
                  call_duration: 60,
                  secondary_clinician_user_id: null,
                  legacy_notes: false,
                  billing_type: "CAREGIVER_TRAINING",
                  healthie_video_call_id: null,
                  call_timezone: "America/New_York",
                  is_recurring: true,
                  parent_video_call_id: "50993",
                  start_time: null,
                  begin_date: null,
                  stop_date: null,
                  stop_type: null,
                  canceled: false,
                  rescheduled: false,
                  video_chat_url:
                    "sendbird_group_channel_191722745_4621ecf678104b5f9f7e40d156ba8bd8a653d619",
                  call_instructions: null,
                  repeat_days: "1,3,5",
                  repeat_type: "until_date",
                  repeat_weeks: null,
                  repeat_until_date: "2025-02-21T06:00:00.000Z",
                  cancel_reason: null,
                  off_platform_type: null,
                  not_started: false,
                  responsible_for_cancellation: null,
                  cancel_date: null,
                  removed: false,
                  healthie_scheduled: false,
                  created_date: "2025-02-13T18:25:14.561Z",
                  onsched_appointment_id: null,
                  description: null,
                  time_interval: 1,
                  time_unit: "weeks",
                  billable_time_id: null,
                  is_tentative: false,
                  master_call_instructions: null,
                  name: "dd",
                  child_last_name: "ddTest",
                  user_id: "144490",
                  primary_clinician_user_id: "144804",
                  client_name: "dd ddTest",
                  team_member_name: "Parentddd Test",
                  clinician_name: "Allie Director",
                  secondary_clinician_name: " ",
                  team_member_image_url: null,
                  clinician_id: "145162",
                  clinician_image_url:
                    "https://an-user-profile-images-staging.s3.amazonaws.com/6763c36d-5aa4-4d9d-80dc-58e4e25aa709/profile_image.png",
                  secondary_clinician_id: null,
                  secondary_clinician_image_url: null,
                  billing_complete: null,
                  video_call_user_id: "144804",
                  is_video_call: true,
                },
                {
                  billing_type: "DIRECT_THERAPY",
                  call_duration: 60,
                  is_tentative: true,
                  client_id: "144752",
                  client_name: "Rita Lopez",
                  clinician_id: "145162",
                  clinician_name: "Allie Director",
                  clinician_image_url:
                    "https://an-user-profile-images-staging.s3.amazonaws.com/9f8d6afa-16e8-4c99-9dc6-1e3831027660/profile_image.png",
                  end: new Date("2025-02-18T20:00:00.000Z"),
                  start: new Date("2025-02-18T21:00:00.000Z"),
                  title: "Client Transition",
                  googleEvent: false,
                  no_show: false,
                  canceled: false,
                  team_member_image_url: null,
                  team_member_name: "Thomas Montes",
                  isNoSelectable: true,
                },
              ],
            },
          },
        },
        three_matching_sessions: {
          active: true,
          condition: {
            urlParams: {
              clinicianid: "143674", // <- use your target clinician's clinicianid
            },
          },
          responseValues: {
            response: [1, 2, 3],
            status: 200,
          },
        },
      },
    },
    POST: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    PUT: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    DELETE: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
  },
};
